<template>
  <v-dialog
   persistent
   v-model="showReAuthDialog"
   max-width="500px"
   :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card>
      <v-container class="modal-pad">
        <v-layout row align-center wrap mb-3>
          <v-flex xs10 style="height:30px;">
            <span class="subheading">Enter your password to confirm.</span>
          </v-flex>
          <v-flex xs2 class="text-xs-right">
            <v-btn fab flat medium @click="closeReAuthDialog">
              <v-icon >close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout row v-if="error">
        <v-flex xs12 >
          <app-alert @dismissed="onDismissed" :text="error.message" :color="error.colour"></app-alert>
        </v-flex>
      </v-layout>
        <v-layout column pt-2>
          <v-flex >
            <p>{{dialogMessage}}</p>
            <v-text-field
              autocomplete="Current password"
              name="auth_password"
              label="Enter your current password to continue"
              id="auth_password"
              placeholder=" "
              v-model="auth_password"
              type="password"
              autofocus
              ref="focus"
              required></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout pt-0 align-end justify-start row fill-height>
          <v-btn style="margin-left:0; margin-right:0;" large depressed color="accent" @click="reAuthenticate" :disabled="!readyForSubmit">Yes, go ahead</v-btn>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/auth'

export default {
  name: 'Reauthenticate',
  props: {
    showReAuthDialog: Boolean,
    dialogMessage: String,
    callback: String
  },
  data () {
    return {
      groupId: this.$store.getters.user.group,
      deleteText: '',
      auth_password: ''
    }
  },
  watch: {
    showReAuthDialog (val) {
      if (!val) return
      requestAnimationFrame(() => {
        this.$refs.focus.focus()
      })
    }
  },
  computed: {
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    },
    group () {
      return this.$store.getters.group
    },
    user () {
      return this.$store.getters.user.id
    },
    readyForSubmit () {
      if (this.auth_password !== '') {
        return true
      }
    }
  },
  methods: {
    onDismissed () {
      this.$store.dispatch('clearError')
    },
    closeReAuthDialog () {
      this.$emit('closeReAuth')
    },
    reAuthenticate () {
      this.$store.dispatch('clearError')
      this.$store.commit('setLoading', true)
      const user = firebase.auth().currentUser
      const credential = firebase.auth.EmailAuthProvider.credential(
        user.email,
        this.auth_password
      )
      user.reauthenticateWithCredential(credential).then(() => {
        // User re-authenticated.
        this.$emit('closeReAuth')
        this.$emit(this.callback)
        // this.$store.commit('setLoading', false)
      }).catch(error => {
        // An error happened.
        this.$store.commit('setError', error)
        this.$store.commit('setLoading', false)
        console.log('error', error)
      })
    }
  }

}
</script>

<style>

</style>
